import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  isSaveBarUpsellPopup: false,
  isSaveBarUpsellBundle: false,
  isSaveBarDesignSetting: false
});

const saveBarReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_UPSELL_POPUP_SETTING_FIELD:
    case types.CHANGE_TARGET_PRODUCT_UPSELL_POPUP:
    case types.CHANGE_LIST_RECOMMEND_POPUP_PRODUCT:
    case types.CHANGE_LIST_TARGET_POPUP_COLLECTION:
    case types.CHANGE_LIST_RECOMMEND_POPUP_COLLECTION:
    case types.CHANGE_DC_TARGET_POPUP_COMMON:
    case types.CHANGE_DC_UPSELL_POPUP_COMMON:
    case types.REMOVE_TARGET_PRODUCT_UPSELL_POPUP:
    case types.REMOVE_RECOMMEND_PRODUCT_UPSELL_POPUP:
    case types.REMOVE_TARGET_COLLECTION_UPSELL_POPUP:
    case types.REMOVE_RECOMMEND_COLLECTION_UPSELL_POPUP:
      return state.set('isSaveBarUpsellPopup', true);
    case types.SAVE_SETTING_UPSELL_POPUP_CAMPAIGN_RESULT:
      if (action.res) {
        return state.set('isSaveBarUpsellPopup', false);
      }
      return state;

    // UPSELL BUNDLE

    case types.CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE:
    case types.REMOVE_TARGET_PRODUCT_UPSELL_BUNDLE:
    case types.CHANGE_UPSELL_BUNDLE_SETTING_FIELD:
      return state.set('isSaveBarUpsellBundle', true);
    case types.SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN_RESULT:
      if (action.res) {
        return state.set('isSaveBarUpsellBundle', false);
      }
      return state;

    // DESIGN SETTING

    case types.CHANGE_DESIGN_SETTINGS_FIELD:
    case types.RESET_DESIGN_SETTING:
      return state.set('isSaveBarDesignSetting', true);
    case types.GET_GLOBAL_SETTING:
      return state.set('isSaveBarDesignSetting', false);
    case types.SAVE_SETTING_DESIGN_RESULT:
      if (action.res) {
        return state.set('isSaveBarDesignSetting', false);
      }
      return state;
    case types.CHANGE_SAVER_BAR_SETTINGS_FIELD:
      return state.set(action.payload.field, action.payload.value);
    default:
      return state;
  }
};

export default saveBarReducer;
